import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { adminApi, setToken, setUser } from "../lib/authApi";

const formatDetail = (detail) => {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").join(" ");
  return "Login failed. Please try again.";
};

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Enter email and password.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      setToken(data.access_token);
      setUser(data.user);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center py-24 px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md p-8 sm:p-10 rounded-xl bg-card border border-border">
        <div className="h-12 w-12 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center mb-6">
          <Lock className="h-5 w-5 text-primary" strokeWidth={1.5} />
        </div>
        <h1 className="text-2xl sm:text-3xl font-medium font-heading tracking-tight">Admin Login</h1>
        <p className="mt-2 text-sm text-muted-foreground">Private access to the Vectron enquiry dashboard.</p>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div className="space-y-2">
            <Label htmlFor="a-email">Email</Label>
            <Input id="a-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" data-testid="admin-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="a-password">Password</Label>
            <Input id="a-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="admin-password-input" />
          </div>
          <Button type="submit" size="lg" disabled={loading} className="w-full rounded-full" data-testid="admin-login-btn">
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
